import { render, staticRenderFns } from "./password-modify.vue?vue&type=template&id=0ae6700e&scoped=true"
import script from "./password-modify.vue?vue&type=script&lang=js"
export * from "./password-modify.vue?vue&type=script&lang=js"
import style0 from "./password-modify.vue?vue&type=style&index=0&id=0ae6700e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6700e",
  null
  
)

export default component.exports